import React from "react";
import { useNavigate } from "react-router-dom";

function ErrorBody(){
    const navigate=useNavigate()

    const reload=()=>{
        window.location.reload()
    }

    return <div className="p-4 text-center">
        <h1 className="mb-3">We are currently updating the server. Please wait a moment and reload the page shortly.</h1>
        <button type="button" onClick={() => reload()} className="text-white bg-primary focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2">Reload</button>
    </div>
}

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
    }
  
    render() {
      if (this.state.hasError) {
        return <ErrorBody/>;
      }
  
      return <>
      {this.props.children}
      </> 
    }
  }

  export default ErrorBoundary